module.exports = __webpack_public_path__ + "static/img/strona_052.d09ef5ec.jpg";